import { Tooltip } from '@material-ui/core';
import React from 'react';

import { EAllowStatus } from '~/src/dash/apiV2/targeting/targetingPresets';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  status: EAllowStatus;
  handleToggleStatus: () => void;
}

export const IncludeExcludeToggle = ({ status, handleToggleStatus }: IProps) => {
  const isStatusDenied = status === EAllowStatus.DENY;
  const tooltip = isStatusDenied ? 'Excluded - Toggle to Include' : 'Included - Toggle to Exclude';
  return (
    <Tooltip title={tooltip} placement='top'>
      <div
        style={{
          height: '32px',
          width: '68px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleToggleStatus}
      >
        <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            {isStatusDenied ? (
              <IconV2 name='unavailable' color={publicaColors.red} />
            ) : (
              <IconV2
                name='available'
                color={publicaColors.green}
                style={{ display: 'inline-block' }}
              />
            )}
          </Col>
          <Col>
            <Text small disableSelect color={publicaColors.darkGray}>
              {isStatusDenied ? 'Exclude' : 'Include'}
            </Text>
          </Col>
        </Cols>
      </div>
    </Tooltip>
  );
};
